export default "/images/framework/Notification.b0305a9c.svg?b0305a9c";